import React, { useState, useEffect } from "react";
import Button from "Components/button/Button";
import Loader from "Components/loader/Loader";
import Input from "Components/input/Input";
import t from "Utils/translation";
import cx from "classnames";
import s from "./orderCustomers.scss";
import QboxmailApi from "@/qboxmailApi";
import { alertSuccess } from "Utils/alerts";
import WarningBanner from "Components/warningBanner/WarningBanner";
import { useParams, useHistory } from "react-router-dom";

function CustomerOrder(props) {
  const { customer, isOrderDeleting, isCustomerLoading } = props;
  const api = new QboxmailApi({ useCookie: true });

  const [submitting, setSubmitting] = useState(false);
  const [whmcsIds, setWhmcsIds] = useState({});

  const { customerCode } = useParams();
  const history = useHistory();

  const showPrices = () => {
    history.push(`/customers/${customerCode}/prices`);
  };

  useEffect(() => {
    const ids = {};
    props.customer.orders.forEach((o) => {
      ids[o.id] = o.whmcs_order_id;
    });

    setWhmcsIds(ids);
  }, [props.customer.code]); // only run it when customer.code change

  const saveOrders = async () => {
    setSubmitting(true);

    let calls = Object.keys(whmcsIds).map((id) => api.editOrder(id, { whmcs_order_id: whmcsIds[id] }));
    await Promise.all(calls);

    alertSuccess(t("alert.customer.updated"));
    setSubmitting(false);

    props.refreshCustomer(props.match.params.customerCode);
  };

  const updateWhmcsId = (orderId, id) => {
    setWhmcsIds({ ...whmcsIds, [orderId]: id });
  };

  const convertUserToMonthly = (e) => {
    props.setFormFieldValue({ convert_to_monthly: true }, () => {
      props.submitForm(e, ["convert_to_monthly"]);
    });
  };

  const renderQuantities = (order) => {
    return (
      <div className={s.quantity}>
        <div className={s.itemQuantity}>
          <div className={s.labelQuantity}>{t("detailInfo.label.account8")}</div>
          <div className={s.dataQuantity}>{order.max_emails_no_8gb}</div>
        </div>
        <div className={s.itemQuantity}>
          <div className={s.labelQuantity}>{t("detailInfo.label.account25")}</div>
          <div className={s.dataQuantity}>{order.max_emails_no_25gb}</div>
        </div>
        <div className={s.itemQuantity}>
          <div className={s.labelQuantity}>{t("detailInfo.label.archive")}</div>
          <div className={s.dataQuantity}>{order.max_emails_no_archive}</div>
        </div>
      </div>
    );
  };

  if (isCustomerLoading) return <Loader />;
  const has_order = customer.orders.length > 0;
  const annually = customer.orders?.[0]?.billing_cycle === "annually";

  return (
    <div className={s.orders}>
      <div className={s.wrapInfoBtn}>
        {has_order && (
          <div className={s.infoBtnGroup}>
            <Button onClick={saveOrders} loading={submitting}>
              button.save
            </Button>
          </div>
        )}
      </div>
      <div className={s.settings}>
        {has_order && annually && (
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">Gestisci ordine annuale</div>
            </div>

            <div className="formsSectionSP">
              <div className={cx("inputFull2")}>
                <WarningBanner
                  msg={
                    "Questo bottone converte l'utente in mensile solo sul pannello, l'operazione su WHMCS va svolta manualmente"
                  }
                />
                <br />
                <Button loading={props.isFormLoading} onClick={convertUserToMonthly}>
                  button.convertMonthly
                </Button>
              </div>
            </div>
          </div>
        )}

        {/*has_order && annually && (
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">Aggiungi dominio a ordine annuale</div>
            </div>

            <div className="formsSectionSP">
              <div className={cx("inputFull2")}>
                <WarningBanner
                  msg={
                    "Questa sezione aggiunge solo il dominio lato Pannello, l'operazione su WHMCS va svolta manualmente"
                  }
                />
                <br />



                <Button loading={props.isFormLoading} onClick={convertUserToMonthly}>
                  Aggiungi dominio al piano annuale dell'utente
                </Button>
              </div>
            </div>
          </div>
        )*/}

        <div className="sectionSP">
          <div className="infoSectionSP">
            <div className="settingTitle">{annually ? "Ordini" : t("settings.sections.customerOrder.title")}</div>
            <a style={{ fontSize: ".875rem" }} onClick={showPrices}>
              Mostra pagina prezzi dell'utente
            </a>
          </div>

          {!has_order && (
            <div className="formsSectionSP">
              <div className={cx(s.noOrder, "inputFull2")}>{t("infoMsg.noOrder")}</div>
            </div>
          )}

          {has_order && (
            <div className="formsSectionSP">
              {customer.orders.map((order) => (
                <div className={cx(s.orderRow, "inputFull2")} key={order.id}>
                  <div className={cx("inputFull2", s.sectionRecap)}>
                    <div className={s.labelRecapt}>{t("detailInfo.label.order.code")}</div>
                    <div className={s.dataRecapt}>{order.code}</div>
                  </div>

                  <div className={cx("inputFull2", s.sectionRecap)}>
                    <div className={s.labelRecapt}>{t("detailInfo.label.order.code")}</div>
                    <div className={s.dataRecapt}>{new Date(order.created_at).toLocaleString()}</div>
                  </div>

                  <div className={cx("inputFull2", s.sectionRecap)}>
                    <div className={s.labelRecapt}>{t("detailInfo.label.order.status")}</div>
                    <div className={s.dataRecapt}>{order.status}</div>
                  </div>
                  <div className={cx("inputFull2", s.sectionRecap)}>
                    <div className={s.labelRecapt}>{t("detailInfo.label.billingCycle")}</div>
                    <div className={s.dataRecapt}>
                      <div>{order.billing_cycle}</div>
                      {order.billing_cycle === "monthly" && renderQuantities(order)}
                    </div>
                  </div>

                  <div className={cx("inputFull2", s.sectionRecap)}>
                    <div className={s.labelRecapt}>{t("detailInfo.label.user.kind")}</div>
                    <div className={s.dataRecapt}>
                      {order.is_company ? t("detailInfo.data.user.company") : t("detailInfo.data.user.privato")}
                    </div>
                  </div>
                  {!annually && (
                    <div className={cx("inputFull2", s.sectionRecap)}>
                      <div className={s.labelRecapt}>{t("detailInfo.label.user.reseller")}</div>
                      <div className={s.dataRecapt}>{order.is_reseller}</div>
                    </div>
                  )}

                  <div className={cx("inputFull2", s.sectionRecap)}>
                    <div className={s.labelRecapt}>{t("detailInfo.label.user.geoArea")}</div>
                    <div className={s.dataRecapt}>{order.geo_area}</div>
                  </div>
                  <div className={cx("inputFull2", s.sectionRecap)}>
                    <div className={s.labelRecapt}>{t("detailInfo.label.user.whmcs.invoiceId")}</div>
                    <div className={s.dataRecapt}>{order.whmcs_invoice_id}</div>
                  </div>
                  <div className={cx("inputFull2", s.sectionRecap)}>
                    <div className={s.labelRecapt}>{t("detailInfo.label.user.whmcs.orderId")}</div>

                    <div className={s.dataRecapt}>
                      <div className={s.dataRecapt}>{whmcsIds[order.id]}</div>
                      {/*<Input
                        name="whmcs_order_id"
                        value={whmcsIds[order.id]}
                        onChange={val => updateWhmcsId(order.id, val.whmcs_order_id)}
                      />*/}
                    </div>
                  </div>

                  <div className={cx("inputFull2", s.btnRecap)}>
                    <Button onClick={() => props.deleteOrder(order.id)} color="red" loading={isOrderDeleting}>
                      button.deleteOrder
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomerOrder;
